// extracted by mini-css-extract-plugin
var _1 = "iiGf1";
var _2 = "Ydwz8";
export { _1 as "type", _2 as "typeContainer" }
